// extracted by mini-css-extract-plugin
export var aircallIframe = "_g8-3";
export var fabContainer = "_g8-5";
export var fabRinging = "_g8-6";
export var loadingOverlay = "_g8-4";
export var pulse = "_g8-7";
export var widgetContent = "_g8-2";
export var widgetPanel = "_g8-0";
export var widgetPanelExpanded = "_g8-1";